export default {
  'EditActMembersListing.removeArtist': {
    en: 'Artist Removed!',
    fr: 'Artiste supprimé!',
  },
  'EditActMembersListing.title': { en: 'members', fr: 'membres' },
};
